import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { DatePipe } from "@angular/common";



@Injectable()
export class AccountDataResolve implements Resolve<any> {

    constructor() {
        
    }
    
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    }

}